export default class Locale_SettingsEditor { 
	UnsavedChanges: string = "Settings has unsaved changes";
	AppSettingsEditor: string = "App settings editor";
}